import { RydeUiUnit } from "@ryde/shared";

import {
  useBulkEditFormContext,
  useCrudEditContext,
  usePageContext,
} from "../../contexts";

export const useResolveEditFormEntity = (): RydeUiUnit => {
  const { entity: gridEntity } = usePageContext();
  const { entity: formEditEntity } = useCrudEditContext();
  const { entity: crudEditEntity } = useCrudEditContext();
  const { isBulkEditForm, entity: bulkEditEntity } = useBulkEditFormContext();

  switch (true) {
    case isBulkEditForm && bulkEditEntity !== "unknown":
      return bulkEditEntity;
    case crudEditEntity && crudEditEntity !== "unknown":
      return crudEditEntity;
    case formEditEntity && formEditEntity !== "unknown":
      return formEditEntity;
    case gridEntity && gridEntity !== "unknown":
      return gridEntity;
    default:
      return "unknown";
  }
};
